import type { ListType } from '../components/results/results-list';

export const useJDPUrlParams = (type: ListType): string => {
  const urlParams = {
    SEARCH: '?ijt=jb_55',
    EMPTY_STATE_SEARCH: '?ijt=jb_37',
    EMPTY_STATE_RECOS: '?ijt=jb_36',
  };

  return urlParams[type] ?? '';
};
